// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12247923","239":"2d6a1917","732":"fd101069"}[chunkId] + ".chunk.js";
};